import { useContext } from 'react';
import {
  CommunicationCountsContext,
  CommunicationCountsContextValue,
} from '../contexts/CommunicationCountsContextDef';

const INERT: CommunicationCountsContextValue = {
  counts: null,
  refresh: async () => {},
};

/**
 * Badge counts for the Communication pages. Unlike useNotifications this does NOT throw outside
 * its provider — leaf consumers (Sidebar, BottomNavigation, CommunicationPage) render in tests
 * without the provider and must degrade to "no badge" rather than crash.
 */
export function useCommunicationCounts(): CommunicationCountsContextValue {
  return useContext(CommunicationCountsContext) ?? INERT;
}
